import { useOgpCompanyTypeContext } from 'ogp/limited-company-capabilities';
import { CheckoutsTypeProvider, useCheckoutsTypeProvider } from './checkouts-type-provider';
import { CheckoutsArchive } from '../shifts-checkouts/archive/checkouts-archive';
import { ProjectsCheckoutsArchive } from '../projects-checkouts/archive/projects-checkouts-archive';

const SharedCheckoutsArchive = () => {
  return (
    <CheckoutsTypeProvider>
      <CheckoutsArchivePage />
    </CheckoutsTypeProvider>
  );
};

const CheckoutsArchivePage = () => {
  const { isLimitedCompany } = useOgpCompanyTypeContext();
  const { type } = useCheckoutsTypeProvider();

  if (isLimitedCompany || type === 'shifts') {
    return <CheckoutsArchive />;
  }

  return <ProjectsCheckoutsArchive />;
};

export { SharedCheckoutsArchive };
